<template>
    <div class="MAM_queryList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="queryForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="queryForm.terminal_sn" placeholder="终端SN"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.merchant_number" placeholder="商户编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.merchant_name" placeholder="商户名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="queryForm.brand_id" clearable placeholder="请选择关联政策">
                        <el-option
                            v-for="item in brandList"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.u_agent_no" placeholder="直属代理编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.s_agent_no" placeholder="所属机构编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.order_id" placeholder="交易单号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="queryForm.terminal_type"
                        clearable
                        placeholder="请选择进件渠道">
                        <el-option label="银盛POS" value="1"></el-option>
                		<el-option label="手机POS" value="2"></el-option>
                		<el-option label="杉德POS" value="3"></el-option>
                		<el-option label="联动POS" value="4"></el-option>
                        <el-option label="海科POS" value="5"></el-option>
                        <el-option label="银盛尊享POS" value="6"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="queryForm.deduct_type" clearable placeholder="请选择扣费类型">
                        <el-option label="首次流量卡" value="1"></el-option>
                        <el-option label="二阶段流量卡" value="2"></el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item>
                    <el-date-picker type="date" placeholder="交易开始时间" v-model="queryForm.start_time"
                        value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
                    -
                    <el-date-picker type="date" placeholder="交易结束时间" v-model="queryForm.end_time"
                        value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
                        @click="onSearch(queryForm)">查询</el-button>

                <el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" icon="el-icon-download"
                    :loading="downLoading" @click="handleDownLoad(queryForm)">导出数据</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">

            <el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
                <!-- 序号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <el-table-column  width="150px"  header-align="center" align="center" prop="terminal_sn" label="终端SN"></el-table-column>
                <el-table-column  width="150px"  header-align="center" align="center" prop="merchant_number" label="商户编号"></el-table-column>
                <el-table-column width="150px" header-align="center" align="center" prop="merchant_name" label="商户名称"></el-table-column>
                <el-table-column width="150px" header-align="center" align="center" prop="brand_name" label="关联政策"></el-table-column>
                <el-table-column width="150px" header-align="center" align="center" prop="terminal_type_text" label="进件渠道"></el-table-column>
                  <el-table-column width="150px" header-align="center" align="center" prop="u_nickname" label="直属代理商昵称"></el-table-column> 
                  <el-table-column width="150px" header-align="center" align="center" prop="u_agent_no" label="直属代理商编号"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="s_nickname" label="所属机构昵称"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="s_agent_no" label="所属机构编号"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="order_id" label="交易单号"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="transaction_money" label="交易金额(元)"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="deduct_type_text" label="扣费类型"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="deduct_amount" label="扣费金额(元)"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="create_time" label="交易时间"></el-table-column>  
            </el-table>
            <!-- 分页部分 -->
            <paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
                @watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
        </el-card>

    </div>
</template>

<script>
    import paginations from '../../../components/pagination/paginations';
    export default {
        name: "mercSpeBundDetail",
        data() {
            return {
                queryForm: {
                    start_time:'',
                    end_time:'',
                    agent_no:'',
                    phone:'',
                    brand_id:'',
                    terminal_sn:'',
                    merchant_name:'',
                    merchant_number:'',
                    terminal_type:'',
                    u_agent_no:'',
                    s_agent_no:'',
                    order_id:'',
                    deduct_type:'',  
                },
                stockTable: { //列表
                    list: [],
                    last_total_money: 0,
                    last_nums: 0,
                    total_money_all: 0,
                },
                page: {
                    currentPage: 1, //当前页码
                    pageSize: 10, //条数
                    total: 0, //总数
                },
                loading: true,
                downLoading: false, //导出loading
                brandList:[]
            }
        },
        mounted() {
            this.page.currentPage = 1;
            this.queryForm.page = this.page.currentPage;
            this.queryForm.limit = this.page.pageSize;
            this.getData(this.queryForm)
            this.getBrandData()
        },
        components: {
            paginations,
        },
        methods: {
            getBrandData() { // 初始化数据
                this.$api.post('brand/brand_list', {}, res => {
                    if (res.code == 0) {
                        this.brandList = res.data.list;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            handleDownLoad(params) { //导出
                let reqData = {
                    type: 32,
                    value: JSON.stringify(params)
                };
            
                this.downLoading = true;
                this.$api.post('export/add', reqData, res => {
                    if (res.code == 0) {
                        this.$message.success(res.msg);
                        this.downLoading = false;
                    } else {
                        this.$message.error(res.msg);
                        this.downLoading = false;
                    }
            
                })
            },
            onSearch(queryForm) {
                this.page.currentPage = 1;
                queryForm.page = this.page.currentPage;
                queryForm.limit = this.page.pageSize;
                // 表单提交
                this.getData(queryForm);
            },
            //分页
            getCurrent(page) {
                // 获取当前页修改的值
                this.page.currentPage = page;
                this.loading = true;
                this.queryForm.page = page;
                this.queryForm.limit = this.page.pageSize;
                this.getData(this.queryForm);
            },
            getPageSize(limit) {
                this.page.currentPage = 1;
                // 获取条数发生改变的值
                this.page.pageSize = limit;
                this.loading = true;
                this.queryForm.page = this.page.currentPage;
                this.queryForm.limit = limit;
                this.getData(this.queryForm);
            },
            getData(params) {
                this.$api.post("transaction_flow_back/selTransactionFlowBackList", params, res => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.page.total = data.count; //总数
                        this.stockTable.list = res.data.list;
                    } else {
                        this.$message.error(res.msg);
                    }
                    // //渲染结束后取消加载
                    this.loading = false;
                })
            }
        }
    };
</script>

<style lang="scss" scope>
    .MAM_queryList {
        .el-input__inner {
            font-size: 12px;
        }

        .el-form-item {
            margin-bottom: 5px;
        }
    }

    .header>.el-card__body {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .headerDivd {
        padding-right: 50px;
        font-size: 14px;
        color: #E6A23C;
    }

    .headerMoney {
        font-size: 28px;
        font-weight: bold;
    }
</style>